import { MapPin, Clock, EnvelopeSimple, Phone } from "@phosphor-icons/react";

export default function Footer({ onDonate }) {
  return (
    <footer data-testid="site-footer" className="bg-[#1F1A17] text-[#FDFBF7]/90">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src="/hearthside-logo.png"
              alt="Hearthside Gathering"
              className="h-52 md:h-64 w-auto object-contain -ml-2"
            />
            <p className="mt-5 text-[#FDFBF7]/70 leading-relaxed max-w-md">
              An evening community space. Home-cooked meals, hygiene supplies, and quiet
              welcome — every night the lantern is lit.
            </p>
            <button
              data-testid="footer-donate-button"
              onClick={onDonate}
              className="btn-hearth mt-7 inline-flex items-center rounded-full bg-[#C25934] hover:bg-[#A04728] px-6 py-3 text-sm font-semibold text-white"
            >
              Make a donation
            </button>
          </div>

          <div className="md:col-span-2">
            <p className="label-eyebrow text-[#E3E9DD] mb-5">Visit</p>
            <ul className="space-y-3 text-[#FDFBF7]/80 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="mt-0.5 text-[#C25934] flex-shrink-0" />
                <span>Location TBD<br /><span className="text-[#FDFBF7]/60 italic">space coming soon</span></span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={18} className="mt-0.5 text-[#C25934] flex-shrink-0" />
                <span>Hours TBD<br /><span className="text-[#FDFBF7]/60 italic">announced soon</span></span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="label-eyebrow text-[#E3E9DD] mb-5">Reach us</p>
            <ul className="space-y-3 text-[#FDFBF7]/80 text-sm">
              <li className="flex items-center gap-3">
                <EnvelopeSimple size={18} className="text-[#C25934] flex-shrink-0" />
                <a href="mailto:susan@hearthsidegathering.org" className="hearth-link break-all">susan@hearthsidegathering.org</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#C25934] flex-shrink-0" />
                <a href="tel:+15038934568" className="hearth-link">(503) 893-4568</a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="label-eyebrow text-[#E3E9DD] mb-5">Explore</p>
            <ul className="space-y-2 text-[#FDFBF7]/80 text-sm">
              <li><a href="#story" className="hearth-link">Our Story</a></li>
              <li><a href="#offer" className="hearth-link">What We Offer</a></li>
              <li><a href="#impact" className="hearth-link">Impact</a></li>
              <li><a href="#volunteer" className="hearth-link">Volunteer</a></li>
              <li><a href="#contact" className="hearth-link">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#FDFBF7]/10 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <p className="text-xs text-[#FDFBF7]/50">
            © {new Date().getFullYear()} Hearthside Gathering. A 501(c)(3) community space.
          </p>
          <p className="font-accent text-2xl text-[#C25934]">
            keep the lantern lit.
          </p>
        </div>
      </div>
    </footer>
  );
}
